import { createContext } from 'react';

import { type Lightbox, STATUS } from './types';

export const LightboxContext = createContext<Lightbox>({
  file: null,
  images: null,
  title: null,
  shouldHideDownload: false,
  shouldHideOpenInNewTab: false,
  initialScale: null,
  isLoading: false,
  status: STATUS.closed,
  open: () => {},
  openImages: () => {},
  close: () => {},
  setIsLoading: () => {},
  setStatus: () => {},
});
